import {Injectable} from "@angular/core";
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { HttpClient } from "@angular/common/http";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PessoaPerfilService {

  constructor(private http: HttpClient) {}

  list(codigo_pessoa_perfil) {
    return this.http.get(environment.UrlPessoaPerfil + '?codigo_pessoa_perfil=' + codigo_pessoa_perfil)
                    .catch(this.handleError);
  }

  find(id) {
    return this.http.get(environment.UrlPessoaPerfil + "/" + id)
                    .catch(this.handleError);
  }

  private handleError(error: Response) {
    return error.json();
  }

}